import React, {Component} from 'react';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {Color} from "../utis/Styles";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import MessageItem from "./MessageItem";
import {
	AgoraEventName,
	AppKey,
	BrowserEventName,
	ChatMessageStatusType, ChatRoomJoinStatus,
	ChatType, MeetingRole,
	MessageContentType, PeerMessageSendResult,
	PeerOnlineStatus
} from "../utis/customEnum";
import RTMClient from "../libs/agoraRtmClient";
import RTCClient, {RTCPublishErrorName, RTCStreamInitErrorName, VideoCodec} from "../libs/agoraRtcClient";
import Calling from "./Calling";
import StreamPlayer from "agora-stream-player";
import withStyles from "@material-ui/core/styles/withStyles";
import HttpTool from "../utis/httpTool";
import {API_TeletHealth, GetAPIBaseURL} from "../utis/API";
import {MD5Tool} from "../utis/cryptTool";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from "@material-ui/core/DialogContent";
import {DialogTitle} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import {amber, green} from '@material-ui/core/colors';
import SnackbarContent from "@material-ui/core/SnackbarContent";
import clsx from "clsx";
import {Logger} from "../utis/Log";
import {FixedSizeList as List} from 'react-window';
import Img from 'react-image'
import {setRole} from "../utis/global";
import {GrayLog} from "../grayLog/grayLog";
import {LogEventName} from "../grayLog/logKey";


const MediaViewBaseZIndex = 1101
const chatListWidth = 480
const timeInterval = (1000)
const captureScreenShotInterval = (60*1) // 1 min
const renderRemoteStreamToViewTimeInterval = (2500)
const remoteVideoWidth = 480
const remoteVideoHeight = 600

const localVideoWidth = 120
const localVideoHeight = 190

class Chat extends Component{
	constructor(props) {
		super(props)
		this.state = {
			messageList: [],
			chatType: ChatType.chatList,
			localStream: null,
			remoteStream: null,
			peerOnlineStatus: PeerOnlineStatus.offline,
			isShowImageDialog: false,
			previewImageUrl: '',
			isVideoChat: true,
			isMuted: false,
			isSpinnerVisible: false,
			isShowAlert: false,
			isShowSnackBar: false,
			isLoading: false,
			captureImageBase64Data: null,
			videoDuration: 0,
			messageScreenShots: [],
			pickerViewSelectedIndex: 0,
			myAccountTipsViewType: TipsViewType.peerChangeToOnOffline,
			myAccountTipsViewOpacity: 1.0,
			isSendInvitationRequest: false,
			sendInvitationRequestCounter: 60,
			isRequesting: false,
			isPatientUseWebVisit: false,
			meetingInfoType: MeetingInfoType.record,
			isRecording: false,
			peerIsMuteVideo: false
		}

		this.isLoginSuccess = false
		this._rtcClient = null
		this._rtmClient = null
		this.channelId = ''
		this.rtmEventListeners = []
		this.alertInfo = null
		this.snackBarInfo = null
		this.hasClickMuteVideoButton = false
		this.timerCounterPeerSecond = 0
		this.pageIndex = 0
		this.pageSize = 30
		this.captureScreenShotCounter = 1
		this.screenShotDateList = []
		this.sessionId = ''
		this.appointmentDate = ''
		this.doctorName = ''
		this.patientName = ''
		this.callToNumber = ''
		this.myPhoneNumber = ''
		this.channelName = ''
		this.mEmployeeId = ''
		this.mPatientId = ''
		this.isShowUploadScreenshotsTips = false
		this.recordMediaUid = 0
		this.recordAudioMediaResourceInfo = {}
		this.recordingType = RecordingType.none
	}

	getMyAccount() {
		return this.myPhoneNumber
	}

	getPeerAccount() {
		return this.callToNumber
	}

	getRtmMyAccount() {
		return (this.myPhoneNumber + '->' + this.getChatId())
	}

	getRtmPeerAccount() {
		return (this.callToNumber + '->' + this.getChatId())
	}

	getSenderId() {
		return this.myPhoneNumber
	}

	getChatId() {
		return this.channelName
	}

	getChannelId() {
		let timeStamp = (new Date()).getTime()
		return MD5Tool.encrypt(this.getChatId()+ '' + timeStamp)
	}

	getMPatientID() {
		return this.mPatientId
	}

	getMEmployeeID() {
		return this.mEmployeeId
	}

	getSessionID() {
		return this.sessionId
	}

	getAppointmentDate() {
		return this.appointmentDate
	}

	getGrayLogInfo(additionalInfo) {
		let base = {
			chatId: this.getChatId(),
			localId: this.getMyAccount(),
			peerId: this.getPeerAccount(),
			chatRole: 'dr',
			eventDate: this.getDateTimeStamp(),
			clinicId: this.clinicId || '',
			meetingInfo: this.meetingInfo || ''
		};

		if (typeof additionalInfo === 'object') {
			return Object.assign(base, additionalInfo);
		} else {
			return base;
		}
	}

	componentDidMount() {
		setRole(MeetingRole.doctor)
		this.addPageEventListener()
		this.getMeetingInfo((isSuccess) =>{
			if (isSuccess) {
				if (this.state.meetingInfoType === MeetingInfoType.chat) { // video chat
					this.canJoinChat((joinStatus, chatId) => {
						if (joinStatus === ChatRoomJoinStatus.canNotJoin && (this.getChatId() === chatId)) {
							this.showAlert(
								'Alert',
								'You are already logged in to this chat room elsewhere, and if you insist on joining, you will be kicked out from other logins. Are you sure you want to join?',
								[
									<Button onClick={() => {
										window.open("about:blank", "_self");
										window.close();
									}} color="primary">
										Cancel
									</Button>,

									<Button onClick={() => {
										this.hideAlert()
										this.joinChatRoom()
									}} color="primary">
										Join
									</Button>
								]
							)
						}else {
							this.joinChatRoom()
						}
					})
				}else {// record
					this.getChatRecordWithAppointmentId()
				}
			}else {
				this.showAlert(
					'Get meeting information error.',
					'Please check the network and reload the page',
					[
						<Button onClick={() => {
							this.reloadCurrentPage()
						}} color="primary">
							Reload
						</Button>
					]
				)
			}
		})

		if (!RTCClient.checkSystemRequirements()) {
			alert("Browser does not support.")
		}
	}

	componentWillUnmount() {
		this.rtmEventListeners.forEach((client) => {
			client && client.removeListener()
		})
	}

	getMeetingInfo(callback) {
		this.meetingInfo = this.props.match.params.meetingInfo
		if (!this.meetingInfo) {
			callback && callback(false)
			return;
		}

		let param = {
			EncryptData: this.meetingInfo
		}

		HttpTool.post(API_TeletHealth.getMeetingInfo, param, (response) => {
			if (response && response.AppointmentID) {
				Logger.print(JSON.stringify(response))
				this.sessionId = response.SessionID
				this.appointmentDate = response.AppointmentDate
				this.doctorName = response.EmployeeName ? response.EmployeeName.trim() : ''
				this.patientName = response.PatientName ? response.PatientName.trim() : ''
				this.callToNumber = 'pt:' + response.MPatientID
				this.myPhoneNumber = 'dr:' + response.MEmployeeID
				this.channelName = response.AppointmentID + '-' + response.ClinicID
				this.mEmployeeId = response.MEmployeeID
				this.mPatientId = response.MPatientID
				this.clinicId = response.ClinicID

				this.setState({meetingInfoType: parseInt(response.MeetingInfoType)})

				callback && callback(true)

				GrayLog.updateCommon(this.getMyAccount())
				GrayLog.event(LogEventName.getMeetingInfo, {isSuccessful: true, token: this.meetingInfo})
			}else {
				callback && callback(false)
				GrayLog.event(LogEventName.getMeetingInfo, {isSuccessful: false, token: this.meetingInfo})
			}
		}, (error) => {
			callback && callback(false)
		})
	}

	joinChatRoom() {
		this.joinChat((isJoinSuccess) => { //check can join before joining chat.
			if (isJoinSuccess) {
				this.initEngine()
			}else {
				this.showAlert(
					'Join chat failed',
					'Please check the network and reload the page',
					[
						<Button onClick={() => {
							this.reloadCurrentPage()
						}} color="primary">
							Reload
						</Button>
					]
				)
			}
		})
	}

	initEngine() {
		this.initRTMClient()
		this.loginAction()
	}

	loginAction() {
		this.login((isLoginSuccess) => {
			this.isLoginSuccess = isLoginSuccess
			if (isLoginSuccess) {
				this.addGlobalTimer()
				this.showSnackBar('Login successfully', SnackBarVariantType.success, 2000)
				this.getHistoryChatRecords(this.getDateTimeStamp(), true)
			}else {
				this.showAlert(
					'Login failed',
					'Please check the network and try again',
					[
						<Button onClick={() => {
							this.hideAlert()
							this.loginAction()
						}} color="primary">
							Login
						</Button>
					]
				)
			}
		})
	}

	addGlobalTimer() {
		this.globalTimerId = setInterval(() => {
			if (this.state.chatType === ChatType.videoChat && this.state.remoteStream) {
				this.timerCounterPeerSecond = this.timerCounterPeerSecond + 1

				 // Logger.print("current: " + this.timerCounterPeerSecond + ' === ' + "next: " + (Math.pow(2,this.captureScreenShotCounter)*captureScreenShotInterval))
				if (this.timerCounterPeerSecond >= (Math.pow(2, this.captureScreenShotCounter)*captureScreenShotInterval)) {
					// Logger.print('timeout,  begin to make screen shot....')
					this.captureScreenShot()
				}

				this.setState({videoDuration: this.timerCounterPeerSecond})
			}else {
				this.timerCounterPeerSecond = 0
			}

			if (this.state.isSendInvitationRequest) {
				if (this.state.sendInvitationRequestCounter === 0) {
					this.setState({isSendInvitationRequest: false})
				}else {
					this.setState({sendInvitationRequestCounter: this.state.sendInvitationRequestCounter - 1})
				}
			}
		}, timeInterval);
	}

	clearGlobalTimer() {
		clearInterval(this.globalTimerId)
	}

	addPageEventListener() {
		window.addEventListener(BrowserEventName.beforeunload, (event) => {
			this.destroyChatRoom()
		});
	}

	destroyChatRoom() {
		if (this.state.meetingInfoType === MeetingInfoType.chat) {
			this.sendBeaconToEndVideo()
			if (this._rtmClient && this._rtmClient.isLogined) {
				this._rtmClient.logout()
				this._rtmClient = null
				this.sendBeaconToLeaveChatRoom()
			}

			for (let i =0; i < 1000000; i ++) {
				for (let j = 0; j < 1000; j ++) {
					;
				}
			}
		}
	}

	joinChat(cb) {
		let param = {
			chatId: this.getChatId(),
			userId: this.getMyAccount(),
			joinDate: this.getDateTimeStamp(),
			sessionID: this.getSessionID(),
			IsWeb : 1
		}

		HttpTool.post(API_TeletHealth.joinChatRoom, param, (response) => {
			if (response?.resultCode === 1) {
				cb && cb(true)
				Logger.print("join chat successfully.")
			}else {
				cb && cb(false)
			}
			GrayLog.event(LogEventName.joinChatRoom, this.getGrayLogInfo({successful: response?.resultCode === 1}));
		},(error) => {
			cb && cb(false)
			Logger.print('join chat fail')
			GrayLog.event(LogEventName.joinChatRoom, this.getGrayLogInfo({successful: false, errMsg: error?.message}));
		})
	}

	canJoinChat(cb) {
		let param = {
			userId: this.getMyAccount(),
			chatId: this.getChatId(),
		}

		this.showSpinner()
		HttpTool.post(API_TeletHealth.canJoinChatRoom, param, (response) => {
			this.hideSpinner()
			Logger.print("Join status: " + JSON.stringify(response))
			if (response) {
				cb && cb(response.CanJoinChatRoom, response.ChatId)
			}else {
				cb && cb(false, '')
			}
		},(error) => {
			Logger.print('can join chat fail')
			this.hideSpinner()

			this.showAlert(
				'Initialization failed',
				'Please check the network and reload the page',
				[
					<Button onClick={() => {
						this.reloadCurrentPage()
					}} color="primary">
						Reload
					</Button>
				]
			)
		})
	}

	leaveChatRoom(chatId, isKickOff = false, cb) {
		let param = {
			chatId: chatId,
			userId: this.getMyAccount(),
			leaveDate: this.getDateTimeStamp(),
			sessionID: this.getSessionID(),
			IsKickOff: isKickOff ? 1 : 0
		}

		HttpTool.post(API_TeletHealth.leaveChatRoom, param, (response) => {
			if (response?.resultCode === 1) {
				cb && cb(true)
				Logger.print("leave chat successfully.")
			}else {
				cb && cb(false)
			}
			GrayLog.event(LogEventName.leaveChatRoom, this.getGrayLogInfo({isKickOff: isKickOff, successful: response?.resultCode === 1}));
		},(error) => {
			Logger.print('leave chat fail')
			cb && cb(false)
			GrayLog.event(LogEventName.leaveChatRoom, this.getGrayLogInfo({isKickOff: isKickOff, successful: false, errMsg: error?.message}));
		})
	}

	sendBeaconToLeaveChatRoom() {
		let leaveChatRoomParam = 'chatId=' + this.getChatId() + '&userId=' + this.getMyAccount() + '&leaveDate=' + this.getDateTimeStamp() + '&sessionID=' + this.getSessionID() + '&IsKickOff=0'
		const blob = new Blob([leaveChatRoomParam], { type: 'application/x-www-form-urlencoded' });
		navigator.sendBeacon(GetAPIBaseURL() + API_TeletHealth.leaveChatRoom, blob);
	}

	sendBeaconToEndVideo() {
		if (this.state.chatType === ChatType.videoChat) {
			let endVideoParam = 'chatId=' + this.getChatId() + '&userId=' + this.getMyAccount() + '&endDate=' + this.getDateTimeStamp() + '&sessionID=' + this.getSessionID()
			const endVideoBlob = new Blob([endVideoParam], { type: 'application/x-www-form-urlencoded' });
			navigator.sendBeacon(GetAPIBaseURL() + API_TeletHealth.endVideo, endVideoBlob);
		}
	}

	beginVideo() {
		let param =  {
			chatId: this.getChatId(),
			userId: this.getMyAccount(),
			beginDate: this.getDateTimeStamp(),
			sessionID: this.getSessionID()
		}

		Logger.print("begin video param: " + JSON.stringify(param))
		HttpTool.post(API_TeletHealth.beginVideo, param, (response) => {
			if (response?.resultCode === 1) {
				Logger.print("begin video successfully.")
			}else {
				Logger.print("begin video fail.")
			}
			GrayLog.event(LogEventName.beginVideo, this.getGrayLogInfo({sessionId: this.getSessionID(), successful: response?.resultCode === 1}));
		}, (error) => {
			Logger.print('begin API error')
			GrayLog.event(LogEventName.beginVideo, this.getGrayLogInfo({sessionId: this.getSessionID(), successful: false, errMsg: error?.message}));
		})

		this.isVideoEnd = false;
	}

	endVideo() {
		if (this.isVideoEnd) { return; }
		this.isVideoEnd = true;

		let duration = this.state.videoDuration || 0;
		let param =  {
			chatId: this.getChatId(),
			userId: this.getMyAccount(),
			endDate: this.getDateTimeStamp(),
			sessionID: this.getSessionID()
		};

		Logger.print("end video param: " + JSON.stringify(param))
		HttpTool.post(API_TeletHealth.endVideo, param, (response) => {
			if (response?.resultCode === 1) {
				Logger.print("end video successfully.")
			}else {
				Logger.print("end video fail.")
			}
			GrayLog.event(LogEventName.endVideo, this.getGrayLogInfo({sessionId: this.getSessionID(), duration: duration, successful: response?.resultCode === 1}));
		}, (error) => {
			Logger.print('end API error')
			GrayLog.event(LogEventName.endVideo, this.getGrayLogInfo({sessionId: this.getSessionID(), duration: duration, successful: false, errMsg: error?.message}));
		})
	}

	initRTMClient() {
		this._rtmClient = new RTMClient(AppKey.AgoraAppKey, (eventName, event) => {
			if (eventName === AgoraEventName.MessageFromPeer) {
				Logger.print('message: ' + JSON.stringify(event))

				let chatRecord = JSON.parse(event.text)
				if (!chatRecord) {
					Logger.print('parse peer msg error: ' + event.text)
					return
				}

				let recordType = chatRecord.type ? chatRecord.type.toLowerCase() : chatRecord.type
				let contentType = MessageContentType.text

				if (recordType.indexOf(MessageContentType.jpg) !== -1) {
					contentType = MessageContentType.jpg
				} else if (recordType.indexOf(MessageContentType.jpeg) !== -1) {
					contentType = MessageContentType.jpeg
				} else if (recordType.indexOf(MessageContentType.png) !== -1) {
					contentType = MessageContentType.png
				}else if (recordType.indexOf(MessageContentType.pdf) !== -1) {
					contentType = MessageContentType.pdf
				}

				let messageInfo = {
					isMine: false,
					type: contentType,
					name: chatRecord.name,
					content: chatRecord.content,
					status: ChatMessageStatusType.finish,
					msgId: this.getMsgId(),
					date: (new Date()),
					chatId: this.getChatId(),
					isFirstRecordChatItem: false
				}

				chatRecord.type = contentType
				this.logRecordMessage(chatRecord, this.getPeerAccount())

				this.setState({
					messageList: this.state.messageList.concat([messageInfo])}, () => {
					setTimeout(() => {
						this.scrollListToBottom()
					}, 300)
				})
			}else if (eventName === AgoraEventName.LocalInvitationAccepted) {
				this.setState({chatType: ChatType.videoChat},() => {
					Logger.print('add fist screen shot ---')
					this.captureScreenShot(() => {
						this.captureScreenShotCounter = 0
					})

					this.beginVideo()
					this.joinChannel()
				})
			}else if (eventName === AgoraEventName.LocalInvitationReceivedByPeer) {
				this.setState({chatType: ChatType.makingCall})
			} else if (eventName === AgoraEventName.LocalInvitationCanceled) {
				this.setState({chatType: ChatType.chatList})
			}else if (eventName === AgoraEventName.LocalInvitationRefused) {
				this.setState({chatType: ChatType.chatList})
			}else if (eventName === AgoraEventName.LocalInvitationFailure) {
				this.setState({chatType: ChatType.chatList})
			}else if (eventName === AgoraEventName.RemoteInvitationReceived) {
				if (this.state.chatType === ChatType.gettingCall ||
					this.state.chatType === ChatType.videoChat
				) {
					event && event.refuse()
					this.sendBusyMessage(event.callerId)
				}else {
					this.channelId = event.channelId
					this.setState({chatType: ChatType.gettingCall})
				}
			}else if (eventName === AgoraEventName.RemoteInvitationCanceled) {
				this.setState({chatType: ChatType.chatList})
			}else if (eventName === AgoraEventName.RemoteInvitationRefused) {
				this.setState({chatType: ChatType.chatList})
			}else if (eventName === AgoraEventName.RemoteInvitationFailure) {
				this.setState({chatType: ChatType.chatList})
			}else if (eventName === AgoraEventName.ConnectionStateChanged) {
				Logger.print('connect status change event: ' + JSON.stringify(event))

				if (event === RTMConnectState.aborted) {
					Logger.print("connection is aborted now.")
					this.clearGlobalTimer()

					if (this.state.chatType === ChatType.videoChat) {
						this.endVideo()

						this.timerCounterPeerSecond = 0
						this.captureScreenShot(() => {
							this.captureScreenShotCounter = 0
							this._rtmClient.endCall()

							this._rtcClient && this._rtcClient.leaveChannel(() => {
								this.setState({
									localStream: null,
									remoteStream: null,
									chatType: ChatType.chatList,
									isMuted: false,
									isVideoChat: true,
									peerIsMuteVideo: false,
								})
							})
						})
					}

					this.leaveChatRoom(this.getChatId(), true,(isLeaveSuccess) => {
						if (isLeaveSuccess) {
							if (this._rtmClient && this._rtmClient.isLogined) {
								this._rtmClient.logout()
								this._rtmClient = null
							}

							this.showAlert(
								'Your account has been logged in elsewhere',
								'Please re-open it from iClinic if you want to log in again.',
								[
									<Button onClick={() => {
										window.open("about:blank", "_self");
										window.close();
									}} color="primary">
										Close
									</Button>
								]
							)
						}
					})


				}else if (event === RTMConnectState.disconnected) {
					this.showSnackBar('Disconnected with server...', SnackBarVariantType.error, 2000)
				}else if (event === RTMConnectState.reconnecting) {
					this.showSnackBar('Reconnecting with server...', SnackBarVariantType.error, 2000)
				}
			}else if (eventName === AgoraEventName.PeersOnlineStatusChanged) {
				if (event && (this.getRtmPeerAccount() in event)) {
					let newStatus = (event[this.getRtmPeerAccount()] === 'OFFLINE') ? PeerOnlineStatus.offline : PeerOnlineStatus.online
					if (newStatus !== this.state.peerOnlineStatus) {
						this.setState({peerOnlineStatus: newStatus}, () => {
							if (newStatus === PeerOnlineStatus.online) {
								this.setState({isSendInvitationRequest: false, isRequesting: false})
								this.updateMyAccountTipsType(TipsViewType.peerChangeToOnline)

								this.checkIsWebVisit((isPatientUseWebVisit) => {
									this.setState({isPatientUseWebVisit: isPatientUseWebVisit})
								})
							}else {
								this.setState({isPatientUseWebVisit: false})
								this.updateMyAccountTipsType(TipsViewType.peerChangeToOnOffline)
							}
						})
					}
				}
			}
		})
	}

	joinChannel() {
		this.captureScreenShotCounter = 0
		Logger.print("channel Name: " + this.channelId)
		this._rtcClient = new RTCClient(this.channelId, VideoCodec.h264, (eventName) => {
			Logger.print('rtc event name: ' + eventName)
			if (eventName === AgoraEventName.StreamPublished) {
				this.setState({localStream: this._rtcClient.localStream})
			}else if (eventName === AgoraEventName.StreamSubscribed) {
				this.showSnackBar('Joining into video chat', SnackBarVariantType.info, 3000)
				this.captureScreenShotCounter = 0
				setTimeout(() => {
					this.setState({remoteStream: this._rtcClient.remoteStream})
				}, renderRemoteStreamToViewTimeInterval)
			} else if (eventName === AgoraEventName.PeerLeave) {
				this.captureScreenShot(() => {
					this.hasClickMuteVideoButton = false
					this.captureScreenShotCounter = 0

					this._rtmClient.endCall()
					this.updateMyAccountTipsType(TipsViewType.endCall)

					this._rtcClient && this._rtcClient.leaveChannel(() => {
						Logger.print('peer live leave rtc channel....')
						this.setState({
							localStream: null,
							remoteStream: null,
							chatType: ChatType.chatList,
							isMuted: false,
							isVideoChat: true,
							peerIsMuteVideo: false,
							videoDuration: this.timerCounterPeerSecond
						})
					})
				})
				this.endVideo()
			}else if (eventName === AgoraEventName.muteAudio) {

			}else if (eventName === AgoraEventName.unmuteAudio) {

			}else if (eventName === AgoraEventName.muteVideo) {
				this.setState({peerIsMuteVideo: true})
			}else if (eventName === AgoraEventName.unmuteVideo) {
				this.setState({peerIsMuteVideo: false})
			}
		})

		this._rtcClient.joinChannel((error) => {
			if (error) {
				const {name, message} = error
				GrayLog.error({message: `${name} - ${message}`}, this.getGrayLogInfo())
				if (name === RTCStreamInitErrorName.deviceNotFound) {
					alert('Media device not found. Please check that your microphone and camera are working properly and that you have permissions to the device.')
				} else if (name === RTCPublishErrorName.invalidOperation && name === RTCPublishErrorName.requestAbort) {
					alert('The connection was lost due to network fluctuations, please check the network and try again.')
				} else if (name === RTCStreamInitErrorName.notAllowed) {
					alert('Please check that your microphone and camera are working properly and that you have permissions to the device.')
				} else {
					alert(`${name} - ${message}`)
				}
			} else {
				alert("Unexpected Error. Please contact digitalhealth@mdland.com")
			}
		})
		this.updateMyAccountTipsType(TipsViewType.none)
	}

	login(callback) {
		this.showSpinner()
		this._rtmClient.login(this.getRtmMyAccount(), (isSuccess) => {
			this.hideSpinner()
			Logger.print('login status: ' + isSuccess)
			if (isSuccess) {
				this._rtmClient.subscribePeersOnlineStatus([this.getRtmPeerAccount()])
				callback && callback(true);
			}else {
				callback && callback(false)
			}
			GrayLog.event(LogEventName.loginRtmServer, this.getGrayLogInfo({account: this.getRtmMyAccount(), successful: isSuccess}));
		})
	}

	checkIsWebVisit(cb) {
		let param = {
			chatId: this.getChatId(),
			userId: this.getPeerAccount() // patient mpid
		}

		HttpTool.post(API_TeletHealth.checkIsWebVisit, param, (response) => {
			Logger.print('checkIsWebVisit: ' + JSON.stringify(response))
			if (response && response.resultCode === 1) {
				cb && cb(true)
			}else {
				cb && cb(false)
			}
		}, () => {
			cb && cb(false)
		})
	}

	sendAction(type, name, content, msgId, status) {
		let messageInfo = {
			isMine: true,
			type: type,
			name: name,
			content: content,
			status: status,
			msgId: msgId ? msgId : this.getMsgId(),
			date: (new Date()),
			chatId: this.getChatId(),
			isFirstRecordChatItem: false
		}

		if (type === MessageContentType.text) {
			this.sendMessage(this.getRtmPeerAccount(), type, name, content)

			this.setState({
				msg: '',
				messageList: this.state.messageList.concat([messageInfo])}, () => {
				setTimeout(() => {
					this.scrollListToBottom()
				}, 400)
			})
		}else {
			this.setState({
				msg: '',
				messageList: this.state.messageList.concat([messageInfo])}, () => {
				setTimeout(() => {
					this.scrollListToBottom()
				}, 400)
			})
		}
	}

	sendBusyMessage(callToNumber) {
		let chatRecord = ({
			senderId: this.getSenderId(),
			type: MessageContentType.text,
			name: '',
			content: 'Sorry, I am busy now. I will call you later.'
		})

		this._rtmClient.sendMessage(JSON.stringify(chatRecord), callToNumber, (sendMessageResult) => {
			if (sendMessageResult !== PeerMessageSendResult.fail) {
				this.logRecordMessage(chatRecord, callToNumber)
			}else {
				this.showSnackBar('Send message fail...', SnackBarVariantType.error, 3000)
			}
		})
	}

	sendMessage(callToNumber, type, name, content) {
		let chatRecord = ({
			senderId: this.getSenderId(),
			type: type,
			name: name,
			content: content
		})

		this._rtmClient.sendMessage(JSON.stringify(chatRecord), callToNumber, (sendMessageResult) => {
			if (sendMessageResult !== PeerMessageSendResult.fail) {
				this.logRecordMessage(chatRecord, this.getPeerAccount());
				GrayLog.event(LogEventName.sendTelehealthMsg, this.getGrayLogInfo({successful: true}));
			}else {
				this.showSnackBar('Send message fail...', SnackBarVariantType.error, 3000);
				GrayLog.event(LogEventName.sendTelehealthMsg, this.getGrayLogInfo({successful: false}));
			}
		})
	}

	logRecordMessage(chatRecord, peerAccount) {
		let param = ({
			chatId: this.getChatId(),
			chatDate: this.getDateTimeStamp(),
			myAccount: this.getMyAccount(),
			peerAccount: peerAccount,
			content: chatRecord
		})

		HttpTool.post(API_TeletHealth.addChatMessageToMongoDB, param, (response) => {
			Logger.print('addTeleHealthMessageToMongoDB response: ' + JSON.stringify(response))
			if (response?.resultCode === 1) {
				Logger.print('log message to mongo success')
			}
		}, (error) => {
			Logger.print('addTeleHealthMessageToMongoDB: ' + JSON.stringify(error))
		})
	}

	getHistoryChatRecords(beforeDate, isScrollToBottom) {
		this.pageIndex = this.pageIndex + 1
		let param = {
			myAccount: this.getMyAccount(),
			peerAccount: this.getPeerAccount(),
			beforeDate: beforeDate
		}

		this.setState({isLoading: true})
		HttpTool.post(API_TeletHealth.loadChatRecordsByDate, param, (response) => {
			if (response && response.length) {
				let records = []
				response.forEach((item, index) => {
					// Logger.print((this.getChatId() + ' ' +  item.content.senderId + ' - ' + item.content.content))
					if (item.content) {
						let messageInfo = {
							isMine: (item.content.senderId + '') === this.getMyAccount(),
							type: item.content.type,
							name: item.content.name,
							content: item.content.content,
							status: ChatMessageStatusType.finish,
							msgId: 0,
							date: (new Date(item.chatDate)),
							chatId: item.chatId,
							isFirstRecordChatItem: false
						}

						records.push(messageInfo)
					}
				})

				records = records.concat(this.state.messageList)
				//比较chatID 并且插入footer - 对话结束时间. 认为同一个chatId就是同一个预约的对话
				records.sort((a, b) => {
					if (a.chatId !== b.chatId) { // different apt
						b.isFirstRecordChatItem = true
					}

					return 0
				})

				if  (records.length) {
					records[0].isFirstRecordChatItem = true
				}


				this.setState({messageList: records}, () => {
					if (isScrollToBottom) {
						setTimeout(() => {
							this.scrollListToBottom()
						}, 1000)
					}
				})
			}else {
				this.showSnackBar('There is no more records...', SnackBarVariantType.info, 3000)
			}
			this.setState({isLoading: false})
		}, (error) => {
			this.setState({isLoading: false})
			this.showRequestChatRecordErrorAlert()
		})
	}

	getChatRecordWithAppointmentId() {
		if (!this.getChatId().length) {
			return;
		}

		let param = {
			ChatID: this.getChatId(),
			MEmployeeID: this.getMEmployeeID(),
		}

		HttpTool.post(API_TeletHealth.loadChatIDRecords, param, (response) => {
			if (!response) {
				this.showRequestChatRecordErrorAlert()
				return
			}

			if (!response.MessageChatDatas.length && !response.MessageScreenShots.length) {
				this.showSnackBar('There is no more records...', SnackBarVariantType.info, 3000)
				return;
			}

			let records = []

			if (response && response.MessageChatDatas &&  response.MessageChatDatas.length) {
				let datas = response.MessageChatDatas

				datas.forEach((item, index) => {
					// Logger.print((this.getChatId() + ' ' +  item.content.senderId + ' - ' + item.chatDate))
					if (item.content) {
						let messageInfo = {
							isMine: (item.content.senderId + '') === this.getMyAccount(),
							type: item.content.type,
							name: item.content.name,
							content: item.content.content,
							status: ChatMessageStatusType.finish,
							msgId: 0,
							date: (new Date(item.chatDate)),
							chatId: item.chatId,
							isFirstRecordChatItem: false
						}

						records.push(messageInfo)
					}
				})

				if (records.length) {
					records[0].isFirstRecordChatItem = true
				}
			}

			this.setState({messageList: records, messageScreenShots: response.MessageScreenShots})
		}, (error) => {
			this.showRequestChatRecordErrorAlert()
		})
	}

	showRequestChatRecordErrorAlert() {
		this.showAlert(
			'Request chat records error.',
			'Please check the network and reload the page',
			[
				<Button onClick={() => {
					this.reloadCurrentPage()
				}} color="primary">
					Reload
				</Button>
			]
		)
	}

	scrollListToBottom() {
		this._listFooter && this._listFooter.scrollIntoView({ behavior: "smooth" });
	}

	scrollListToTop() {
		this._listHeader && this._listHeader.scrollIntoView({ behavior: "smooth" });
	}

	getChromeVersion () {
		let raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
		return raw ? parseInt(raw[2], 10) : false;
	}

	reloadCurrentPage() {
		window.location.reload();
	}

	getMsgId() {
		let encodeString = this.getMyAccount().toLowerCase() + this.getPeerAccount().toLowerCase() + ((new Date()).getTime() + '')
		return  MD5Tool.encrypt(encodeString).toUpperCase()
	}

	getDateTimeStamp() {
		return (new Date()).toISOString()
	}

	formatVideoDuration(duration) {
		let hour = parseInt(((duration/3600) +''))
		let min = parseInt((duration%3600)/60 +'')
		let second = duration%60

		if (second < 10) {
			second = '0' + second
		}

		if (min < 10) {
			min = '0' + min
		}

		if (hour < 10) {
			hour = '0' + hour
		}

		return hour + ':' + min + ':' + second
	}

	compareDateIsInAdate(aDate, bDate) {
		return (aDate.getFullYear === bDate.getFullYear &&
			aDate.getMonth() === bDate.getMonth() &&
			aDate.getDate() === bDate.getDate())
	}

	compressImage(e, callback) {
		let file = e.target.files[0];
		let fileType = file.type;

		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = event => {
			const img = new Image();

			img.src = event.target.result;
			img.onload = () => {
				const elem = document.createElement('canvas');

				const newImageScale = this.scaleImageSize(img.width, img.height)
				const width = newImageScale.width;
				const height = newImageScale.height

				elem.width = newImageScale.width
				elem.height = newImageScale.height

				const ctx = elem.getContext('2d');
				ctx.drawImage(img, 0, 0, width, height);
				let imageData = ctx.canvas.toDataURL(fileType || 'image/jpeg')

				callback && callback(imageData)
			}
			reader.onerror = error => {
				callback && callback(null)
			};
		};
	}

	scaleImageSize(width, height) {
		if (width < 1000 && height < 1000) {
			return {width: width, height: height}
		}else if (width > 1000 && width >= height) {
			let scale = 1000.0/width
			return {width: 1000, height: parseInt(height*scale)}
		}else {
			let scale = 1000.0/height
			return {width: parseInt(width*scale), height: 1000}
		}
	}

	sendFile(fileType, fileName, imageBase64WithHeader) {
		fileType = fileType.toLowerCase()
		let imageDataInfo = imageBase64WithHeader.split(',')
		if (imageDataInfo && imageDataInfo.length === 2) {
			let base64Data = imageDataInfo[1]
			let contentType = MessageContentType.jpg

			if (fileType.indexOf(MessageContentType.jpg) !== -1) {
				contentType = MessageContentType.jpg
			} else if (fileType.indexOf(MessageContentType.jpeg) !== -1) {
				contentType = MessageContentType.jpeg
			} else if (fileType.indexOf(MessageContentType.png) !== -1) {
				contentType = MessageContentType.png
			}else if (fileType.indexOf(MessageContentType.pdf) !== -1) {
				contentType = MessageContentType.pdf
			}

			let msgId = this.getMsgId()
			this.sendAction(contentType, fileName, imageBase64WithHeader, msgId, ChatMessageStatusType.loading) // send but not send to rtm server.
			this.uploadImage(contentType, fileName, base64Data, msgId)
		}
	}

	uploadImage(type, name, base64Data, msgId) {
		let param = JSON.stringify({
			name: name,
			type: type,
			content: base64Data
		})

		HttpTool.post(API_TeletHealth.saveAttachment, param,(response) => {
			Logger.print('upload files response: ' + JSON.stringify(response))
			if (response.url && response.url.length) {
				this.sendMessage(this.getRtmPeerAccount(), type, name, response.url)

				let list = this.state.messageList.map((item) => {
					if (item.msgId === msgId) {
						item.content  = response.url // update content with url
						item.status = ChatMessageStatusType.finish // update status
					}

					return item
				})

				this.setState({chatList: list})
			}
		}, (error) => {
			let list = this.state.messageList.map((item) => {
				if (item.msgId === msgId) {
					item.status = ChatMessageStatusType.fail // update status
				}

				return item
			})

			this.setState({chatList: list})
		})
	}

	captureScreenShot(callback) {
		if (!this._renderStreamCanvas) {
			callback && callback()
			return;
		}

		// for remote
		let remoteStreamContext = this._renderStreamCanvas.getContext('2d');
		this._renderStreamCanvas.setAttribute('width', remoteVideoWidth);
		this._renderStreamCanvas.setAttribute('height', remoteVideoHeight);

		// for remote
		if (this.state.remoteStream) {
			let remoteVideo = document.getElementById('video' + this.state.remoteStream.getId());
			if (remoteVideo) {
				remoteStreamContext.clearRect(0, 0, this._renderStreamCanvas.width, this._renderStreamCanvas.height)
				remoteStreamContext.drawImage(remoteVideo, 0, 0, this._renderStreamCanvas.width, this._renderStreamCanvas.height);
			}
		}

		// for local
		if (this.state.localStream) {
			let localVideo = document.getElementById('video' + this.state.localStream.getId());
			if (localVideo) {
				remoteStreamContext.drawImage(localVideo, remoteVideoWidth - localVideoWidth - 20, 50, localVideoWidth, localVideoHeight);
			}
		}

		remoteStreamContext.font = "24px Arial";
		remoteStreamContext.fillStyle = "#ff0000";
		remoteStreamContext.textAlign = "center";
		let duration = this.formatVideoDuration(this.state.videoDuration);
		remoteStreamContext.fillText(duration, this._renderStreamCanvas.width/2.0, 30,)

		let muteImage = (this.state.isMuted ? require('../assets/images/audio_mute.png') : require('../assets/images/audio_unmute.png'))
		let endCallImage = require('../assets/images/reject.png')
		let videoImage = (this.state.isVideoChat ? require('../assets/images/video_voice.png') : require('../assets/images/video_video.png'))
		// let screenShotImage =  require('../resource/images/screen_shot.png')
		// let recordAudioImage = this.state.isRecording && this.recordingType === RecordingType.audio ? require('../resource/images/audio_record_off.png') : require('../resource/images/audio_record_on.png')
		// let recordVideoImage = this.state.isRecording && this.recordingType === RecordingType.video ? require('../resource/images/screen_record_off.png') : require('../resource/images/screen_record_on.png')
		let iconSize = 50
		let iconMargin = (remoteVideoWidth - iconSize*3)/4.0//(remoteVideoWidth - iconSize*5)/6.0
		let hudViewHeight = 90//130
		let padding = 20

		remoteStreamContext.fillStyle = 'rgba(0,0,0, 0.3)'
		remoteStreamContext.fillRect(0, remoteVideoHeight - hudViewHeight, remoteVideoWidth, hudViewHeight)

		this.canvasDrawImage(muteImage, (muteImageRef) => {
			if (muteImageRef) {
				remoteStreamContext.drawImage(muteImageRef, iconMargin, remoteVideoHeight - hudViewHeight + padding, iconSize, iconSize)
			}

			this.canvasDrawImage(endCallImage, (endCallImageRef) => {
				if (endCallImageRef) {
					remoteStreamContext.drawImage(endCallImageRef, iconMargin*2 + iconSize, remoteVideoHeight - hudViewHeight + padding, iconSize, iconSize)
				}

				this.canvasDrawImage(videoImage, (videoImageRef) => {
					if (videoImageRef) {
						remoteStreamContext.drawImage(videoImageRef, iconMargin*3 + iconSize*2, remoteVideoHeight - hudViewHeight + padding, iconSize, iconSize)
					}

					this.saveScreenShot(this._renderStreamCanvas, callback)
				})
			})
		})

		// this.canvasDrawImage(muteImage, (muteImageRef) => {
		// 	if (muteImageRef) {
		// 		remoteStreamContext.drawImage(muteImageRef, iconMargin, remoteVideoHeight - marginTop, iconSize, iconSize)
		// 	}
		//
		// 	this.canvasDrawImage(videoImage, (endCallImageRef) => {
		// 		if (endCallImageRef) {
		// 			remoteStreamContext.drawImage(endCallImageRef, iconMargin*2 + iconSize, remoteVideoHeight - marginTop, iconSize, iconSize)
		// 		}
		//
		// 		this.canvasDrawImage(screenShotImage, (videoImageRef) => {
		// 			if (videoImageRef) {
		// 				remoteStreamContext.drawImage(videoImageRef, iconMargin*3 + iconSize*2, remoteVideoHeight - marginTop, iconSize, iconSize)
		// 			}
		//
		// 			this.canvasDrawImage(recordAudioImage, (videoImageRef) => {
		// 				if (videoImageRef) {
		// 					remoteStreamContext.drawImage(videoImageRef, iconMargin*4 + iconSize*3, remoteVideoHeight - marginTop, iconSize, iconSize)
		// 				}
		//
		// 				this.canvasDrawImage(recordVideoImage, (videoImageRef) => {
		// 					if (videoImageRef) {
		// 						remoteStreamContext.drawImage(videoImageRef, iconMargin*5 + iconSize*4, remoteVideoHeight - marginTop, iconSize, iconSize)
		// 					}
		//
		// 					this.canvasDrawImage(endCallImage, (videoImageRef) => {
		// 						if (videoImageRef) {
		// 							remoteStreamContext.drawImage(videoImageRef, remoteVideoWidth/2.0 - iconSize/2.0, remoteVideoHeight - marginTop + iconSize + 5, iconSize, iconSize)
		// 						}
		//
		// 						this.saveScreenShot(this._renderStreamCanvas, callback)
		// 					})
		// 				})
		// 			})
		// 		})
		// 	})
		// })
	}

	saveScreenShot(canvas, callback) {
		if (!canvas) {
			return;
		}

		let imageData = canvas.toDataURL('image/jpeg')
		// this.setState({captureImageBase64Data: imageData})
		let imageDataInfo = imageData.split(',')
		if (imageDataInfo && imageDataInfo.length === 2) {
			let base64Data = imageDataInfo[1]
			this.uploadScreenShot(base64Data)
		}

		this.captureScreenShotCounter = this.captureScreenShotCounter + 1
		callback && callback()
		this.clearCanvas()
	}

	canvasDrawImage(src,callback) {
		let image = new Image()

		image.src = src
		image.onload= (() => {
			callback && callback(image)
		})
		image.onerror=(() => {
			callback && callback(null)
		})
	}

	clearCanvas() {
		this._renderStreamCanvas && this._renderStreamCanvas.setAttribute('width', 0);
	}

	uploadScreenShot(photoBase64) {
		let param = {
			chatId: this.getChatId(),
			shotDate: this.getDateTimeStamp(),
			photo: photoBase64
		}

		this.screenShotDateList.push(this.getDateTimeStamp())

		Logger.print("save screen shot param: " + JSON.stringify(param))
		HttpTool.post(API_TeletHealth.addChatScreenShot, param, (response) => {
			Logger.print('addTeleHealthScreenShot response: ' + JSON.stringify(response))
			if (response?.resultCode === 1 && this.isShowUploadScreenshotsTips) {
				this.showSnackBar('Capture screenshots successfully...', SnackBarVariantType.success, 3000)
				this.isShowUploadScreenshotsTips = false
			}
		}, (error) => {
			//
		})
	}

	updateMyAccountTipsType(newType) {
		if (this.state.peerOnlineStatus === PeerOnlineStatus.offline) {
			newType = TipsViewType.peerChangeToOnOffline
		}

		if (newType === TipsViewType.none) {
			this.addFadeAnimationToTipsView(FadeType.hide,() => {
				this.setState({myAccountTipsViewType: newType})
			})
		}else {
			this.setState({myAccountTipsViewType: newType, myAccountTipsViewOpacity: 0.0}, () => {
				this.addFadeAnimationToTipsView(FadeType.show)
			})
		}
	}

	addFadeAnimationToTipsView(fadeType ,cb) {
		this.fadeCount = 0
		this.fadeIntervalId = setInterval(() => {
			if (fadeType === FadeType.show) {
				this.setState({myAccountTipsViewOpacity: this.state.myAccountTipsViewOpacity + 0.2})
				this.fadeCount = this.fadeCount + 1

				if (this.fadeCount > 4) {
					this.clearFadeInterval()
					cb && cb()
				}
			}else {
				this.setState({myAccountTipsViewOpacity: this.state.myAccountTipsViewOpacity - 0.1})
				this.fadeCount = this.fadeCount + 1

				if (this.fadeCount > 9) {
					this.clearFadeInterval()
					cb && cb()
				}
			}

		}, 100)
	}

	clearFadeInterval() {
		this.fadeCount = 0
		clearInterval(this.fadeIntervalId);
	}

	getPatientShortName() {
		let shortName = ''
		let patientName = this.getPatientName()
		if (!patientName || !patientName.length) {
			return shortName
		}

		let arr2 = patientName.split(",")
		if (arr2.length > 1) {
			shortName = (arr2[0]).trim().charAt(0) + (arr2[1]).trim().charAt(0)

			return shortName.toUpperCase()
		}

		let arr1 = patientName.split(" ")
		if (arr1.length > 1) {
			shortName = (arr1[0]).trim().charAt(0) + (arr1[1]).trim().charAt(0)

			return shortName.toUpperCase()
		}

		if (patientName.length > 1) {
			shortName = patientName.substr(0, 2)
		}else {
			shortName = patientName.charAt(0)
		}

		return shortName.toUpperCase()
	}

	getPatientName() {
		return this.patientName
	}

	getDoctorName() {
		return this.doctorName
	}

	getDoctorShortName() {
		let shortName = ''
		let doctorName = this.getDoctorName()
		if (!doctorName || !doctorName.length) {
			return shortName
		}

		let arr2 = doctorName.split(",")
		if (arr2.length > 1) {
			shortName = (arr2[0]).trim().charAt(0) + (arr2[1]).trim().charAt(0)

			return shortName.toUpperCase()
		}

		let arr1 = doctorName.split(" ")
		if (arr1.length > 1) {
			shortName = (arr1[0]).trim().charAt(0) + (arr1[1]).trim().charAt(0)

			return shortName.toUpperCase()
		}

		if (doctorName.length > 1) {
			shortName = doctorName.substr(0, 2)
		}else {
			shortName = doctorName.charAt(0)
		}

		return shortName.toUpperCase()
	}



	getRandomInteger() {
		let min = 100000
		let max = 99999999
		return Math.floor(Math.random() * (max - min) ) + min;
		//与stream.getId() 不能重复
	}

	generateAudioId() {
		return MD5Tool.encrypt(this.getChatId())
	}

	startRecording(recordType) {
		let api = (recordType === RecordingType.audio ? API_TeletHealth.startRecordingAudio : API_TeletHealth.startRecordingVideo)
		this.recordMediaUid = this.getRandomInteger()
		let postData = {
			cname: this.channelId,
			uid: this.recordMediaUid
		}

		let param = {
			telelHealthID: this.generateAudioId(),
			recordingPostData: postData
		}

		HttpTool.post(api, param, (response) => {
			Logger.print("start record: " + JSON.stringify(response))
			if (response && response.code === 0) {
				this.recordAudioMediaResourceInfo = response
			}else {
				this.setState({isRecording: false})
			}
		}, (error) => {
			this.setState({isRecording: false})
			Logger.print("start to record error")
		})
	}

	stopRecording() {
		let postData = {
			cname: this.channelId,
			uid: this.recordMediaUid
		}

		let param = {
			resourceid: this.recordAudioMediaResourceInfo.resourceId,
			sid: this.recordAudioMediaResourceInfo.sid,
			recordingPostData: postData
		}

		HttpTool.post(API_TeletHealth.stopRecording, param, (response) => {
			Logger.print("stop record: " + JSON.stringify(response))
			if (response && response.code === 0) {
				this.showSnackBar('Record video successfully', SnackBarVariantType.success, 3000)
			}

			this.recordMediaUid = 0
			this.recordAudioMediaResourceInfo = {}
		}, (error) => {
			Logger.print("stop to record error")
		})
	}

	showIsRecordingMediaAlert(recordingType) {
		let title = 'Recording ' + (recordingType === RecordingType.video ? 'video' : 'audio') + ' now!'
		let desc = "Press stop button to finish recording."
		this.showAlert(
			title,
			desc,
			[
				<Button onClick={() => {
					this.setState({isShowAlert: false})
				}} color="primary">
					Cancel
				</Button>,
				<Button onClick={() => {
					this.recordingType = RecordingType.none
					this.setState({isShowAlert: false, isRecording: false})
					this.stopRecording()
				}} color="secondary">
					Stop
				</Button>,
			]
		)
	}

	showRecordMediaAlert(recordingType) {
		this.recordingType = recordingType
		if (recordingType === RecordingType.video) {
			this.setState({isShowAlert: false, isRecording: true}, () => {
				this.startRecording(RecordingType.video)
			})
		}else {
			this.setState({isShowAlert: false, isRecording: true}, () => {
				this.startRecording(RecordingType.audio)
			})
		}

		// let title = 'Record ' + (recordingType === RecordingType.video ? 'video.' : 'audio.')
		// let desc = "Click to record " + (recordingType === RecordingType.video ? 'video.' : 'audio')
		// this.showAlert(
		// 	title,
		// 	desc,
		// 	[
		// 		<Button onClick={() => {
		// 			this.setState({isShowAlert: false})
		// 		}} color="secondary">
		// 			Cancel
		// 		</Button>,
		//
		// 		<Button onClick={() => {
		// 			this.recordingType = recordingType
		// 			if (recordingType === RecordingType.video) {
		// 				this.setState({isShowAlert: false, isRecording: true}, () => {
		// 					this.startRecording(RecordingType.video)
		// 				})
		// 			}else {
		// 				this.setState({isShowAlert: false, isRecording: true}, () => {
		// 					this.startRecording(RecordingType.audio)
		// 				})
		// 			}
		// 		}} color="primary">
		// 			Confirm
		// 		</Button>,
		// 	]
		// )
	}

	renderRows() {
		let items = this.state.messageList.map((item, index) => {
			return (
				<MessageItem
					key = {index}
					isMine={item.isMine}
					userShortName = {item.isMine ? this.getDoctorShortName() : this.getPatientShortName()}
					content = {item.content}
					type = {item.type}
					status = {item.status}
					name = {item.name}
					chatDate = {item.date}
					isFirstRecordChatItem = {item.isFirstRecordChatItem}
					previewImageAction={(type, imgUrl, name) => {
						this.previewInfo = {
							type: type,
							content: imgUrl,
							name: name
						}
						this.setState({isShowImageDialog: true})
					}}
				/>
			)
		})

		return items
	}

	renderLiveView() {
		if (this.state.chatType === ChatType.makingCall ||
			this.state.chatType === ChatType.gettingCall
		) {
			return (
				<Calling
					isMakeCall = {this.state.chatType === ChatType.makingCall}
					peerUserName = {this.getPatientName()}
					cancelCall={() => {
						Logger.print('cancel call')
						this.setState({chatType: ChatType.chatList})
						this._rtmClient.cancelCall()
					}}
					refuseCall={()=> {
						this._rtmClient.refuseCall()
						Logger.print('refuse call')
						this.setState({chatType: ChatType.chatList})
					}}
					acceptCall={() => {
						Logger.print('accept call')
						this._rtmClient.acceptCall()
						this.setState({chatType: ChatType.videoChat},() => {
							Logger.print('add fist screen shot ---')
							this.captureScreenShot(() => {
								this.captureScreenShotCounter = 0
							})

							this.beginVideo()
							this.joinChannel()
						})

						this.updateMyAccountTipsType(TipsViewType.none)
					}}
				/>
			)
		} else if (this.state.chatType === ChatType.videoChat) {
			return this.renderVideoView()
		}

		return null
	}

	renderVideoActionButton() {
		if (!this.state.remoteStream) {
			return null
		}

		const {classes} = this.props

		return(
			<div className={classes.videoButtonActionContainer}>
				<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', width: '100%',
					height: 50,
					marginTop: 20,
					marginBottom: 20,
				}}>
					<Button onClick={() => {
						this.setState({isMuted: !this.state.isMuted})
					}}  className={classes.mediaButton}>
						<img alt={'unmute'} style={{width: 50, height: 50}}  src={this.state.isMuted ?  require('../assets/images/audio_mute.png') : require('../assets/images/audio_unmute.png')} />
					</Button>

					<Button onClick={() => {
						this.timerCounterPeerSecond = 0
						this.endVideo()
						this.captureScreenShot(() => {
							this.captureScreenShotCounter = 0
							this._rtmClient.endCall()
							this.updateMyAccountTipsType(TipsViewType.endCall)

							this._rtcClient && this._rtcClient.leaveChannel(() => {
								this.hasClickMuteVideoButton = false
								this.setState({
									localStream: null,
									remoteStream: null,
									chatType: ChatType.chatList,
									isMuted: false,
									isVideoChat: true,
									peerIsMuteVideo: false,
									videoDuration: this.timerCounterPeerSecond
								})
							})
						})
					}} className={classes.mediaButton}>
						<img alt={'reject'} style={{width: 50, height: 50}}  src={require('../assets/images/reject.png')} />
					</Button>

					<Button onClick={() => {
						this.hasClickMuteVideoButton = true
						this.setState({isVideoChat: !this.state.isVideoChat})
					}} className={classes.mediaButton}>
						<img alt={'video'} style={{width: 50, height: 50}} src={this.state.isVideoChat ? require('../assets/images/video_voice.png') :
							require('../assets/images/video_video.png')
						} />
					</Button>
				</div>

			</div>
		)

		// return(
		// 	<div className={classes.videoButtonActionContainer}>
		// 		<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', width: '100%',
		// 			height: 50,
		// 			marginTop: 20,
		// 			marginBottom: 10,
		// 		}}>
		// 			<Button onClick={() => {
		// 				this.setState({isMuted: !this.state.isMuted})
		// 			}}  className={classes.mediaButton}>
		// 				<img alt={'unmute'} style={{width: 50, height: 50}}  src={this.state.isMuted ?  require('../resource/images/audio_mute.png') : require('../resource/images/audio_unmute.png')} />
		// 			</Button>
		//
		// 			<Button onClick={() => {
		// 				this.hasClickMuteVideoButton = true
		// 				this.setState({isVideoChat: !this.state.isVideoChat})
		// 			}} className={classes.mediaButton}>
		// 				<img alt={'video'} style={{width: 50, height: 50}} src={this.state.isVideoChat ? require('../resource/images/video_voice.png') :
		// 					require('../resource/images/video_video.png')
		// 				} />
		// 			</Button>
		//
		// 			<Button onClick={() => {
		// 				if (this.isShowUploadScreenshotsTips) {
		// 					return
		// 				}
		//
		// 				this.isShowUploadScreenshotsTips = true
		// 				this.captureScreenShot()
		// 			}} className={classes.mediaButton}>
		// 				<img alt={'video'} style={{width: 50, height: 50}} src={
		// 					require('../resource/images/screen_shot.png')
		// 				} />
		// 			</Button>
		//
		// 			<Button onClick={() => {
		// 				if (this.state.isRecording) {
		// 					this.showIsRecordingMediaAlert(RecordingType.audio)
		// 					return
		// 				}
		//
		// 				this.showRecordMediaAlert(RecordingType.audio)
		// 			}} className={classes.mediaButton}>
		// 				<img alt={'video'} style={{width: 50, height: 50}} src={
		// 					(this.state.isRecording  && this.recordingType === RecordingType.audio ? require('../resource/images/audio_record_off.png') : require('../resource/images/audio_record_on.png'))
		// 				} />
		// 			</Button>
		//
		// 			<Button onClick={() => {
		// 				if (this.state.isRecording) {
		// 					this.showIsRecordingMediaAlert(RecordingType.video)
		// 					return
		// 				}
		//
		// 				this.showRecordMediaAlert(RecordingType.video)
		// 			}} className={classes.mediaButton}>
		// 				<img alt={'video'} style={{width: 50, height: 50}} src={
		// 					(this.state.isRecording && this.recordingType === RecordingType.video ? require('../resource/images/screen_record_off.png') : require('../resource/images/screen_record_on.png'))
		// 				} />
		// 			</Button>
		// 		</div>
		//
		// 		<Button onClick={() => {
		// 			this.timerCounterPeerSecond = 0
		// 			this.endVideo()
		// 			this.captureScreenShot(() => {
		// 				this.captureScreenShotCounter = 0
		// 				this._rtmClient.endCall()
		// 				this.updateMyAccountTipsType(TipsViewType.endCall)
		//
		// 				this._rtcClient && this._rtcClient.leaveChannel(() => {
		// 					this.hasClickMuteVideoButton = false
		// 					this.setState({
		// 						localStream: null,
		// 						remoteStream: null,
		// 						chatType: ChatType.chatList,
		// 						isMuted: false,
		// 						videoDuration: this.timerCounterPeerSecond
		// 					})
		// 				})
		// 			})
		// 		}} className={classes.mediaButton}>
		// 			<img alt={'reject'} style={{width: 50, height: 50}}  src={require('../resource/images/reject.png')} />
		// 		</Button>
		//
		// 	</div>
		// )
	}

	renderVideoDurationView() {
		if (this.state.chatType === ChatType.videoChat && this.state.remoteStream) {
			return(
				<Typography style={{width: remoteVideoWidth, top: 15, textAlign: 'center',
					color: Color.red, fontSize: 18, position: 'absolute',
					left: 0, zIndex:MediaViewBaseZIndex + 2
				}}>
					{this.formatVideoDuration(this.state.videoDuration)}
				</Typography>
			)
		}
	}

	renderVideoView(){
		const {classes} = this.props
		return(
			<div className={classes.videoContainer}>
				{this.renderStreamCanvas()}

				{this.renderRemoteStreamView()}
				{this.renderLocalStreamView()}

				{this.renderVoiceChatOnlyView()}
				{this.renderPeerIsMuteTipsView()}

				{this.renderVideoActionButton()}
				{this.renderVideoDurationView()}
			</div>
		)
	}

	renderLocalStreamView(){

		return(this.state.localStream ?
				<StreamPlayer
					video={this.state.isVideoChat}
					audio={!this.state.isMuted}
					stream={this.state.localStream}
					fit="cover"
					placeholder={
						<div style = {{
							backgroundColor: Color.black,
							width: '100%',
							height: '100%',
						}}>
							{/*<Typography variant={'h5'} style={{color: Color.white}}>{'Voice chat...'}</Typography>*/}
						</div>
					}
					style = {{
						position: 'absolute',
						width: localVideoWidth,
						height: localVideoHeight,
						top: 50,
						right: 20,
					}}
				/>
			:  null)
	}

	renderRemoteStreamView(){
		let playerStyle = {
			left: 0,
			top: 0,
			position: 'absolute',
			width: remoteVideoWidth,
			height: remoteVideoHeight,
			overflow: 'hidden'
		}

		if (this.getChromeVersion() <= 78 && this.getChromeVersion() >=74) {
			if (!this.hasClickMuteVideoButton) {
				playerStyle = {
					left: 0,
					top: 0,
					position: 'absolute',
					width: remoteVideoWidth,
					height: remoteVideoHeight,
					overflow: 'hidden'
				}
			}else {
				playerStyle= {
					left: -60,
					top: 60,
					position: 'absolute',
					width: remoteVideoHeight,
					height: remoteVideoWidth,
					transform: 'rotate(90deg)',
					overflow: 'hidden'
				}
			}
		}

		return(this.state.remoteStream ?
				<StreamPlayer
					video={this.state.isVideoChat}
					audio={true}
					stream={this.state.remoteStream}
					fit="cover"
					placeholder={
						<div style = {{
							backgroundColor: Color.black,
							width: remoteVideoWidth,
							height: remoteVideoHeight,
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						</div>
					}
					style = {playerStyle}
				/>
			:  null)
	}

	renderStreamCanvas() {
		let playerStyle = {
			left: 0,
			top: 0,
			position: 'absolute',
			width: remoteVideoWidth,
			height: remoteVideoHeight,
			overflow: 'hidden'
		}

		if (this.getChromeVersion() <= 78 && this.getChromeVersion() >= 74) {
			if (!this.hasClickMuteVideoButton) {
				playerStyle = {
					left: 0,
					top: 0,
					position: 'absolute',
					width: remoteVideoWidth,
					height: remoteVideoHeight,
					overflow: 'hidden'
				}
			}else {
				playerStyle= {
					left: -60,
					top: 60,
					position: 'absolute',
					width: remoteVideoHeight,
					height: remoteVideoWidth,
					transform: 'rotate(90deg)',
					overflow: 'hidden'
				}
			}
		}

		return (
			<canvas style={playerStyle} ref={(o) => {
				this._renderStreamCanvas = o
			}} />
		)

	}

	renderVoiceChatOnlyView() {
		if (this.state.remoteStream && !this.state.isVideoChat) {
			return (
				<div style={{
					position: 'absolute',
					width: remoteVideoWidth,
					height: remoteVideoHeight,
					justifyContent: 'center',
					alignItems: 'center',
					display: 'flex',
					flexDirection: 'column',
					backgroundColor: Color.black,
					zIndex:MediaViewBaseZIndex,
				}}>
					<Typography style={{color: Color.white}} variant={'h5'}>{'Voice chat...'}</Typography>
				</div>
			)
		}
	}

	renderPeerIsMuteTipsView() {
		if (this.state.remoteStream && this.state.peerIsMuteVideo) {
			return (
				<div style={{
					position: 'absolute',
					width: remoteVideoWidth,
					height: remoteVideoHeight,
					justifyContent: 'center',
					alignItems: 'center',
					display: 'flex',
					flexDirection: 'column',
					backgroundColor: Color.black,
					zIndex:MediaViewBaseZIndex,
				}}>
					<Typography style={{color: Color.white}} variant={'h5'}>{'The video is disabled by peer'}</Typography>
				</div>
			)
		}
	}

	renderPreviewContentView() {
		if (!this.previewInfo) {
			return ;
		}

		let contentType = this.previewInfo.type
		let content = this.previewInfo.content

		if (contentType === MessageContentType.pdf) {
			return(
				<object width={500} height={500} data={content} aria-label={""}/>
			)
		}else {
			return(
				<img style={{margin: 'auto',
					display: 'block',
					maxWidth: 600,
					maxHeight: 600,}} alt={'preview'} src={content}/>
			)
		}
	}

	renderLoading() {
		return(
			<Dialog
				open={this.state.isSpinnerVisible}
				onClose={() => {

				}}
			>
				<DialogContent>
					<div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
						<CircularProgress size={40}/>
						<Typography variant={'h5'} style={{marginTop: 10}}>{'Loading ...'}</Typography>
					</div>

				</DialogContent>
			</Dialog>
		)
	}

	showSpinner() {
		this.setState({isSpinnerVisible: true})
	}

	hideSpinner() {
		this.setState({isSpinnerVisible: false})
	}

	showAlert(title, desc, actions) {
		this.alertInfo = {
			title: '',
			desc: '',
			actions: []
		}
		this.alertInfo.title = title
		this.alertInfo.desc = desc
		this.alertInfo.actions = actions
		this.setState({isShowAlert: true})
	}

	hideAlert() {
		this.alertInfo = null
		this.setState({isShowAlert: false})
	}

	renderAlertDialog() {
		if (!this.alertInfo) {
			return
		}

		let title = this.alertInfo.title
		let desc = this.alertInfo.desc
		let actions = this.alertInfo.actions

		if (!actions || !actions.length) {
			actions.push(<Button onClick={() => {
				this.setState({isShowAlert: false})
			}} color="primary">
				Dismiss
			</Button>)
		}

		return(
			<Dialog
				open={this.state.isShowAlert}
				onClose={() => {

				}}
			>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					{desc}
				</DialogContent>
				<DialogActions>
					{actions}
				</DialogActions>
			</Dialog>
		)
	}

	showSnackBar(title, variant, duration) {
		this.snackBarInfo = {}
		this.snackBarInfo.title = title
		this.snackBarInfo.variant = variant
		this.snackBarInfo.duration = duration

		this.setState({isShowSnackBar: true})
	}

	hideSnackBar() {
		this.snackBarInfo = null
		this.setState({isShowSnackBar: false})
	}

	renderSnackBar() {
		const { classes } = this.props
		if (!this.snackBarInfo) {
			return null
		}

		let variant = this.snackBarInfo.variant ?  this.snackBarInfo.variant : 'success'
		let duration = this.snackBarInfo.duration ? this.snackBarInfo.duration : 4000

		return(
			<Snackbar
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'center',
				}}
				open={this.state.isShowSnackBar}
				autoHideDuration={duration}
				onClose={() => {
					this.hideSnackBar()
				}}
			>
				<SnackbarContent
					className={clsx(classes[variant])}
					aria-describedby="client-snackbar"
					message={
						<span id="client-snackbar" className={classes.message}>
							{this.snackBarInfo.title}
        				</span>
					}

				/>
			</Snackbar>
		)
	}

	renderMediaPreviewDialog() {
		return(
			<Dialog
				open={this.state.isShowImageDialog}
				onClose={() => {

				}}
			>
				<DialogTitle>{this.previewInfo ? this.previewInfo.name : ''}</DialogTitle>
				<DialogContent>
					{this.renderPreviewContentView()}
				</DialogContent>
				<DialogActions>
					<Button onClick={() => {
						this.setState({isShowImageDialog: false})
						if (this.previewInfo && this.previewInfo.content && (this.previewInfo.content.indexOf('http') !== -1)) {
							let win = window.open(this.previewInfo.content, '_blank');
							win.focus();
						}else {
							alert('Please wait for upload to complete')
						}
					}} color="primary">
						Open in new tab
					</Button>
					<Button onClick={() => {
						this.setState({isShowImageDialog: false})
					}} color="primary">
						Dismiss
					</Button>
				</DialogActions>
			</Dialog>
		)
	}

	renderImageScannerView() {
		if (this.state.messageScreenShots.length) {
			return(
				<div style={{width: remoteVideoWidth, height: remoteVideoHeight,}}>
					<List
						layout="horizontal"
						height={remoteVideoHeight}
						itemCount={50}
						itemSize={remoteVideoHeight}
						width={remoteVideoWidth}
					>
						{({ index, style }) => {
							let imageInfo = this.state.messageScreenShots[index]
							Logger.print(JSON.stringify(imageInfo))
							return(
								<img style={{width: remoteVideoWidth, height: remoteVideoHeight}} src={imageInfo.PhotoLink} alt={""}/>
							)
						}}
					</List>
				</div>
			)
		}

		return null
	}

	renderImagePicker() {
		const {classes} = this.props

		if (this.state.messageScreenShots.length) {
			let imageInfo = this.state.messageScreenShots[this.state.pickerViewSelectedIndex]
			return(
				<Paper className={classes.cardVideo}>
					<div style={{display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						position: 'relative',
						width: '100%',
						height: '100%'
					}}>

						<div style={{width: remoteVideoWidth, height: remoteVideoHeight, position: 'absolute',
							left:0, top: 0, display: 'flex', flexDirection: 'row', justifyContent: 'center',
							alignItems: 'center'
						}}>
							<CircularProgress size={35} className={classes.imageLoading}/>
						</div>
						<Img
							style={{width: remoteVideoWidth, height: remoteVideoHeight, position: 'absolute',
								left:0, top: 0,
							}}
							src={imageInfo.PhotoLink}
						/>

						<div style={{width: '100%',
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}>
							<Button onClick={() => {
								let nextIndex = this.state.pickerViewSelectedIndex
								if (this.state.pickerViewSelectedIndex === 0) {
									this.showSnackBar('This is the first screen shot.', SnackBarVariantType.info, 2000)
									return
								}else {
									nextIndex = nextIndex - 1
								}

								this.setState({pickerViewSelectedIndex: nextIndex})
							}}>
								<img alt={'previous'} style={{width: 45, height: 60, marginLeft: -18}}  src={require('../assets/images/previous.png')} />
							</Button>

							<Button onClick={() => {
								let nextIndex = this.state.pickerViewSelectedIndex
								if (nextIndex < this.state.messageScreenShots.length -1) {
									nextIndex = nextIndex + 1
								}else {
									this.showSnackBar('This is the last screen shot.', SnackBarVariantType.info, 2000)
									return
								}

								this.setState({pickerViewSelectedIndex: nextIndex})
							}}>
								<img alt={'next'} style={{width: 45, height: 60, marginRight: -18}}  src={require('../assets/images/next.png')} />
							</Button>
						</div>

						<Typography style={{
							position: 'absolute',
							top: 20,
							right: 20,
							textAlign: 'center',
							color: Color.theme,
							fontSize: 24,
						}}>
							{(this.state.pickerViewSelectedIndex + 1) + '/' + this.state.messageScreenShots.length}
						</Typography>
					</div>
				</Paper>
			)
		}
	}

	renderMyAccountTipsView() {
		let type = this.state.myAccountTipsViewType
		let desc = ''
		if (type === TipsViewType.peerChangeToOnline) {
			desc = this.getPatientName() + ' is online now. You can click the video icon below to start the video chat'
		}else if (type === TipsViewType.endCall) {
			desc = this.getPatientName() + ' is online now. You can still send messages. If you want to terminate the session, click the sign out button in the upper right corner to sign out.'
		}else if (type === TipsViewType.peerChangeToOnOffline) {
			desc = this.getPatientName() + ' is offline now. All the messages you sent are offline messages.'
		} else {
			return null
		}

		return(
			<div style={{width: '100%', backgroundColor: type === TipsViewType.peerChangeToOnOffline ? '#F9cA7B' : '#ADDB7C',
				position: 'absolute', left: 0, bottom: 0, right: 0, opacity: this.state.myAccountTipsViewOpacity,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center'
			}}>
				<Typography style={{
					marginLeft: 40,
					marginRight: 40,
					paddingTop: 8,
					paddingBottom: 8,
					fontSize: 14,
				}} >{desc}</Typography>

				{this.isLoginSuccess && type === TipsViewType.peerChangeToOnOffline ? (
					<Button onClick={() => {
						if (!this.state.isSendInvitationRequest && !this.state.isRequesting) {
							this.inviteToChat()
						}
					}} style={{height: 40, width: '95%', marginTop: 10, marginBottom: 10, backgroundColor: (this.state.isSendInvitationRequest || this.state.isRequesting) ? Color.lightGray : '#7ED321'}} >
						{this.state.isRequesting ? <CircularProgress size={20} style={{marginLeft: 15, color: Color.white}}/> : <Typography style={{
							fontSize: 16,
							color: Color.white
						}} >{this.state.isSendInvitationRequest ?  (this.state.sendInvitationRequestCounter + 's') : 'Invite to chat'}</Typography>}
					</Button>
				) : null}
			</div>
		)
	}

	inviteToChat() {
		let param = {
			MPatientID: this.getMPatientID(),
			ChatID: this.getChatId(),
			MEmployeeID: this.getMEmployeeID()
		}

		this.setState({isRequesting: true})
		HttpTool.post(API_TeletHealth.inviteToChat, param, (response)=> {
			this.setState({isRequesting: false})
			if (response && response.resultCode === 1) {
				this.showSnackBar('Invitation sent', SnackBarVariantType.info, 2000)
				this.setState({isSendInvitationRequest: true, sendInvitationRequestCounter: 60})
			}else {
				let title = 'Invitation sending failed'
				let desc = 'The patient does not have an iClinicHealth account or mobile phone, please complete it and try again.'
				this.showAlert(
					title,
					desc,
					[
						<Button onClick={() => {
							this.setState({isShowAlert: false})
						}} color="primary">
							OK
						</Button>,
					]
				)
			}
			GrayLog.event(LogEventName.sendChatInvites, this.getGrayLogInfo({successful: response?.resultCode === 1}));
		}, (error) => {
			this.setState({isRequesting: false})
			this.showSnackBar('An error occurred', SnackBarVariantType.info, 2000)
			GrayLog.event(LogEventName.sendChatInvites, this.getGrayLogInfo({successful: false, errMsg: error?.message}));
		})
	}

	signOut() {
		if (this.state.meetingInfoType === MeetingInfoType.chat) {
			if (this.state.chatType === ChatType.videoChat) {
				//your are chatting with video now.
				let title = 'You\'re in the call. The call will be terminated before you quit.'
				let desc = ''
				this.showAlert(
					title,
					desc,
					[
						<Button onClick={() => {
							this.setState({isShowAlert: false})
						}} color="primary">
							Dismiss
						</Button>,

						<Button onClick={() => {
							this.captureScreenShot(() => {
								this.captureScreenShotCounter = 0
								this._rtmClient.endCall()

								this.endVideo()
								this._rtcClient && this._rtcClient.leaveChannel(() => {
									this.hasClickMuteVideoButton = false
									this.setState({
										localStream: null,
										remoteStream: null,
										chatType: ChatType.chatList,
										videoDuration: this.timerCounterPeerSecond
									})
								})

								this.setState({isShowAlert: false})
							})
						}} color="secondary">
							Confirm
						</Button>
					]
				)
			}else if (this.state.peerOnlineStatus === PeerOnlineStatus.online){
				//peer online still.
				let title = 'The patient is still online, do you want to leave?'
				let desc = ''
				this.showAlert(
					title,
					desc,
					[
						<Button onClick={() => {
							this.setState({isShowAlert: false})
						}} color="primary">
							Dismiss
						</Button>,

						<Button onClick={() => {
							this.leaveChatRoom(this.getChatId(), false,() => {
								if (this._rtmClient && this._rtmClient.isLogined) {
									this._rtmClient.logout()
									this._rtmClient = null
								}

								window.open("about:blank", "_self");
								window.close();
							})
						}} color="secondary">
							Confirm
						</Button>
					]
				)
			}else {
				this.leaveChatRoom(this.getChatId(), false, () => {
					if (this._rtmClient && this._rtmClient.isLogined) {
						this._rtmClient.logout()
						this._rtmClient = null
					}

					window.open("about:blank", "_self");
					window.close();
				})
			}
		}
	}

	renderLiveChatMessageList() {
		const {classes} = this.props

		let type = this.state.myAccountTipsViewType
		let footerHeight = 20
		if (this.isLoginSuccess && type === TipsViewType.peerChangeToOnOffline) {
			footerHeight = 150
		}else if (this.isLoginSuccess && type === TipsViewType.peerChangeToOnline) {
			footerHeight = 80
		}

		return(
			<div className={classes.listViewContainer}>
				<div className={classes.listView }>
					<div ref = {(o) => {
						this._listHeader = o
					}} className={classes.listHeader} >
						{this.state.isLoading ? (<CircularProgress style={{marginTop: 12}} size={20} />) : (
							<Button onClick={() => {
								if (this.state.messageList && this.state.messageList.length) {
									let beforeDate = this.state.messageList[0].date.toISOString()
									this.getHistoryChatRecords(beforeDate, false)
								}else {
									this.showSnackBar('There is no more records...', SnackBarVariantType.info, 3000)
								}
							}} fullWidth={true} color="primary">
								Show previous messages
							</Button>
						)}
					</div>
					{this.renderRows()}

					<div ref = {(o) => {
						this._listFooter = o
					}} style={{width: '100%', height: footerHeight}} />
				</div>
				{this.renderMyAccountTipsView()}
			</div>
		)
	}

	renderChatRecordList() {
		const {classes}  = this.props
		return(
			<div className={classes.chatRecordListViewContainer}>
				<div className={classes.listViewFullHeight}>
					{this.renderRows()}
					<div ref = {(o) => {
						this._listFooter = o
					}} className={classes.listFooter} />
				</div>
			</div>
		)
	}

	renderLiveChatToolBar() {
		const { classes } = this.props
		return (
			<div className={classes.toolBarBgView}>
				<div className={classes.toolBar}>
					<div className={classes.toolBarMediaBgView}>
						<div onClick={() => {
							if (this.state.isPatientUseWebVisit) {
								this.showAlert(
									'Alert',
									'No message allowed for web visit, please advise patient to download iClinicHealth app.',
									[
										<Button onClick={() => {
											this.hideAlert()
										}} color="primary">
											OK
										</Button>
									]
								)
							}
						}}>
							<input
								accept={'image/jpeg,image/bmp,image/png,application/pdf'}
								style={{ display: 'none',}}
								id="button-file"
								type="file"
								disabled={this.state.isPatientUseWebVisit}
								onChange = {(event) => {
									if (event.target.files && event.target.files[0]) {
										let file = event.target.files[0]
										let fileName = file.name
										let fileType = file.type

										if (fileType.indexOf(MessageContentType.pdf) !== -1) {
											let reader = new FileReader();
											reader.onload = (e) => {
												let imageBase64WithHeader = e.target.result
												if (imageBase64WithHeader) {
													this.sendFile(fileType, fileName, imageBase64WithHeader)
												}
											};

											reader.readAsDataURL(file);
										}else { //only compress Image.
											this.compressImage(event, (imageData) => {
												let imageBase64WithHeader = imageData
												if (imageBase64WithHeader) {
													this.sendFile(fileType, fileName, imageBase64WithHeader)
												}
											})
										}
									}

									event.target.value = ''
								}}
							/>
							<label style={{
								height: 28
							}} htmlFor="button-file">
								<Button component="span" className={classes.toolBarFileButton}>
									<img alt={'file'} style={{width: 20, height: 20}} src={require('../assets/images/file.png')}/>
								</Button>
							</label>
						</div>

						<Button onClick={() => {
							if (this.state.peerOnlineStatus === PeerOnlineStatus.online &&
								this.state.chatType === ChatType.chatList
							) {
								this.channelId = this.getChannelId()
								this._rtmClient.makeCall(this.getRtmPeerAccount(), this.channelId)
								this.updateMyAccountTipsType(TipsViewType.none)
							}else if (this.state.peerOnlineStatus !== PeerOnlineStatus.online) {
								let title = "Patient " + this.getPatientName() + ' is offline.'
								this.showSnackBar(title,  SnackBarVariantType.error, 3000)
							}else if (this.state.chatType === ChatType.gettingCall) {
								this.showSnackBar('You are getting the call now.',  SnackBarVariantType.error, 3000)
							}else if (this.state.chatType === ChatType.makingCall) {
								this.showSnackBar('You are making the call now.',  SnackBarVariantType.error, 3000)
							}else if (this.state.chatType === ChatType.videoChat) {
								this.showSnackBar('You are chatting now.',  SnackBarVariantType.error, 3000)
							}
						}} >
							<img alt={'phone'} style={{width: 27, height: 18}} src={require('../assets/images/video_call.png')}/>
						</Button>
					</div>

					<Button  className={classes.toolBarSendButton} onClick={() => {
						if (this.state.isPatientUseWebVisit) {
							this.showAlert(
								'Alert',
								'No message allowed for web visit, please advise patient to download iClinicHealth app.',
								[
									<Button onClick={() => {
										this.hideAlert()
									}} color="primary">
										OK
									</Button>
								]
							)

							return;
						}

						if (!this.state.msg || !this.state.msg.length) {
							this.showSnackBar('please input your message...', SnackBarVariantType.warning, 2000)
							return
						}
						this.sendAction(MessageContentType.text, '', this.state.msg, this.getMsgId(), ChatMessageStatusType.finish)

						if (this.state.peerOnlineStatus === PeerOnlineStatus.offline) {
							this.setState({myAccountTipsViewType: TipsViewType.peerChangeToOnOffline, myAccountTipsViewOpacity: 1.0})
						}else {
							this.updateMyAccountTipsType(TipsViewType.none)
						}
					}}>
						<img alt={'send'} style={{width: 20, height: 20}} src={require('../assets/images/send.png')}/>
					</Button>
				</div>

				<div onClick={() => {
					if (this.state.isPatientUseWebVisit) {
						this.showAlert(
							'Alert',
							'No message allowed for web visit, please advise patient to download iClinicHealth app.',
							[
								<Button onClick={() => {
									this.hideAlert()
								}} color="primary">
									OK
								</Button>
							]
						)
					}
				}}>
					<TextField
						id="standard-multiline-static"
						multiline
						placeholder={'Text here...'}
						value={this.state.msg}
						className={classes.textField}
						rowsMax={4}
						disabled={this.state.isPatientUseWebVisit}
						onChange={(event) => {
							this.setState({msg: event.target.value})
						}}
						InputProps={{
							disableUnderline: true,
							height: '100%',
						}}
						onKeyPress={(event) => {
							if (event.key === 'Enter') {
								if (!this.state.msg || !this.state.msg.length) {
									this.showSnackBar('please input your message...', SnackBarVariantType.warning, 2000)
									return
								}

								this.sendAction(MessageContentType.text, '', this.state.msg, this.getMsgId(), ChatMessageStatusType.finish)
								event.preventDefault()

								if (this.state.peerOnlineStatus === PeerOnlineStatus.offline) {
									this.setState({myAccountTipsViewType: TipsViewType.peerChangeToOnOffline, myAccountTipsViewOpacity: 1.0})
								}else {
									this.updateMyAccountTipsType(TipsViewType.none)
								}
							}
						}}
					/>
				</div>

			</div>
		)
	}

	renderPageFooter() {
		const { classes } = this.props
		const year = (new Date()).getFullYear()
		const footer = '© 1999-' + year + ' MDLAND.com. All Rights Reserved.'

		return(
			<Typography variant={'body2'} className={classes.footer}>
				{footer}
			</Typography>
		)
	}

	renderAppBar() {
		const { classes } = this.props

		let appTitle = ''
		if (this.state.meetingInfoType === MeetingInfoType.record) {
			appTitle = this.getPatientName() + ' - ' + this.getAppointmentDate()
		}else {
			appTitle = this.getPatientName() + ' - ' + this.state.peerOnlineStatus
		}

		return(
			<AppBar position="static" className={classes.appBar}>
				<Toolbar>
					<Typography variant="h6" className={classes.appTitle}>
						{appTitle}
					</Typography>

				</Toolbar>

				{this.state.meetingInfoType === MeetingInfoType.chat ?
					<Toolbar>
						<Button onClick={() => {
							this.signOut()
						}} color="inherit">
							<Typography variant="h6" className={classes.appTitle}>
								{'Sign out'}
							</Typography>
						</Button>
					</Toolbar> : null
				}
			</AppBar>
		)
	}

	render() {
		const { classes } = this.props

		return(
			<div id={'mainBoard'} className={classes.main}>
				{this.renderAppBar()}
				<div className={classes.chatTextBgView}>
					<Paper className={classes.cardChat}>
						{this.state.meetingInfoType === MeetingInfoType.chat ? this.renderLiveChatMessageList() : this.renderChatRecordList()}
						<div className={classes.divider}/>

						{this.state.meetingInfoType === MeetingInfoType.chat ? this.renderLiveChatToolBar() : null}
					</Paper>

					{this.state.meetingInfoType === MeetingInfoType.chat ? (
						this.state.chatType !== ChatType.chatList ? (
								<Paper  className={classes.cardVideo}>
									{this.renderLiveView()}
								</Paper>
							) : null
					) :
						this.renderImagePicker()
					}
				</div>

				{this.renderMediaPreviewDialog()}
				{this.renderAlertDialog()}
				{this.renderLoading()}
				{this.renderSnackBar()}
				{this.renderPageFooter()}

				{/*<img src={this.state.captureImageBase64Data} />*/}
				{/*<div style={{width: 100, height: 200,}}></div>*/}
			</div>
		)
	}
}

const SnackBarVariantType = {
	success: 'success',
	error: 'error',
	info: 'info',
	warning: 'warning',
}


const RTMConnectState = {
	aborted: 'ABORTED',
	connected: 'CONNECTED',
	connecting:'CONNECTING',
	disconnected:'DISCONNECTED',
	reconnecting:'RECONNECTING',
}

const MeetingInfoType = {
	chat: 0,
	record: 1,
}

const TipsViewType = {
	none: 0,
	peerChangeToOnline: 1,
	peerChangeToOnOffline: 2,
	endCall: 3,
}

const FadeType = {
	show: 0,
	hide: 1
}

const styles = (theme) => ({
	main: {
		width: '100%',
		backgroundColor: '#F9FAFB',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	chatTextBgView: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center'
	},
	appBar: {
		backgroundColor: Color.theme,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	appTitle: {
		Color: Color.white
	},
	loginButton: {
		marginLeft: 20,
		color: Color.white
	},
	cardChat: {
		width: 480,
		marginTop: 30,
		marginBottom: 30,
	},
	chatRecordListViewContainer: {
		width: '100%',
		height: remoteVideoHeight,
		backgroundColor: Color.white,
		overflow: 'auto',
		position: 'relative',
	},
	listViewContainer: {
		width: '100%',
		height: 450,
		backgroundColor: Color.white,
		overflow: 'auto',
		position: 'relative',
	},
	listView: {
		width: '100%',
		height: 450,
		backgroundColor: Color.white,
		overflow: 'auto',
		position: 'relative',
	},
	listViewFullHeight: {
		width: '100%',
		height: remoteVideoHeight,
		backgroundColor: Color.white,
		overflow: 'auto'
	},
	noDataContainer: {
		width: '100%',
		height: '100%',
		flex: 'display',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	toolBarBgView: {
		width: '100%',
		height: 150,
	},
	toolBar: {
		width: '100%',
		height: 50,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	toolBarMediaBgView: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		height: 50,
		marginLeft: 10
	},
	toolBarFileButton: {
		marginRight: 24,
	},
	toolBarSendButton: {
		marginRight: 10,
	},
	divider: {
		width: '100%',
		height: 1,
		backgroundColor: Color.lineColor
	},
	textField: {
		width: chatListWidth - 20,
		marginLeft: 10,
		height: 90,
	},
	cardVideo: {
		width: 480,
		marginTop: 30,
		marginBottom: 30,
		backgroundColor: Color.black,
		height: remoteVideoHeight,
		marginLeft: 24
	},
	videoButtonActionContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: 'rgba(0, 0, 0, 0.3)',
		zIndex: MediaViewBaseZIndex + 1,
	},
	audioChatButton: {
		zIndex: MediaViewBaseZIndex + 1
	},
	videoChatButton: {
		zIndex: MediaViewBaseZIndex + 1
	},
	cancelVideoButton: {
		zIndex: MediaViewBaseZIndex + 1,
		marginBottom: 10,
	},
	mediaButton: {
		zIndex: MediaViewBaseZIndex + 1,
		width: 60,
		height: 60,
	},
	videoContainer: {
		width: '100%',
		height: '100%',
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-end',
		alignItems: 'center'
	},
	listHeader: {
		width: '100%',
		height: 44,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	listFooter: {
		width: '100%',
		height: 120,
	},
	toolBarFileInput: {
		//
	},
	success: {
		backgroundColor: green[600],
	},
	error: {
		backgroundColor: theme.palette.error.dark,
	},
	info: {
		backgroundColor: theme.palette.primary.main,
	},
	warning: {
		backgroundColor: amber[700],
	},
	icon: {
		fontSize: 20,
	},
	iconVariant: {
		opacity: 0.9,
		marginRight: theme.spacing(1),
	},
	message: {
		display: 'flex',
		alignItems: 'center',
	},
	footer: {
		color: Color.black,
		marginTop: 30,
		marginBottom: 30,
	},
	imageLoading: {
		color: Color.white
	},
	patientWebVisitCoverView: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		backgroundColor: Color.red
	}
})

const RecordingType = {
	none: 0,
	audio: 1,
	video: 2,

}

export default withStyles(styles)(Chat)
